export const colors = {
  ok: '#DFF0D0',
  okBorder: '#62A420',
  warning: '#FEF3B5',
  warningBorder: '#EDB200',
  error: '#F5DBD9',
  errorBorder: '#e12200',

  edge: '#c1cdd4',
};
